import { render } from "./Contact.vue?vue&type=template&id=0da375cd"
const script = {}

import exportComponent from "E:\\project2\\skin-web\\英雄攻战\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__